// src/pages/AdminArticles.js
import React, { useEffect, useState } from 'react';
import axios from '../utils/axiosConfig'; //新增CSRF設定
import API_URL from '../config';
import { useTranslation } from 'react-i18next'; // 引入 i18n
import { useNavigate, Link } from 'react-router-dom'; // 引入 useNavigate 與 Link
import { useLoading } from '../contexts/LoadingContext';

function AdminArticles() {
  const [articles, setArticles] = useState([]);
  const { t } = useTranslation(); // 使用 i18n
  const navigate = useNavigate(); // 用於導航
  const { showLoading, hideLoading } = useLoading();

  useEffect(() => {
    const fetchArticles = async () => {
      showLoading();
      try {
        const response = await axios.get(`${API_URL}/api/admin/articles`, { withCredentials: true });
        setArticles(response.data);
      } catch (error) {
        console.error('獲取文章時發生錯誤：', error);
        if (error.response && error.response.status === 401) {
          // 未登入，重定向到登入頁面
          navigate('/login');
        } else if (error.response && error.response.status === 403) {
          // 無權限，顯示錯誤訊息或重定向
          alert(t('accessDenied'));
          navigate('/');
        }
      } finally {
        hideLoading();
      }
    };
    
    fetchArticles();
  }, [navigate, t, showLoading, hideLoading]);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-black dark:text-white">
      {/* 頁面容器 */}
      <div className="container mx-auto px-4 py-6">
        {/* 新增：導覽列（從 AdminDashboard 複製） */}
        <nav className="flex flex-wrap space-x-4 mb-6">
          <Link
            to="/admin/users"
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            {t('manageUsers')}
          </Link>
          <Link
            to="/admin/api-usage"
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            {t('viewApiUsage')}
          </Link>
          <Link
            to="/admin/articles"
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            {t('manageArticles')}
          </Link>
          <Link
            to="/admin/articles/create"
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            {t('createArticle')}
          </Link>
          <Link
            to="/admin/videos"
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            {t('manageVideos')}
          </Link>
          <Link
            to="/admin/videos/create"
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            {t('createVideo')}
          </Link>
          <Link
            to="/admin/update-log"
            className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400"
          >
            {t('manageUpdateLogs')}
          </Link>
        </nav>
        
        <h2 className="text-2xl font-bold mb-4">{t('articleManagement')}</h2>
        <div className="overflow-x-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr>
                <th className="px-4 py-2 border-b dark:border-gray-700">{t('title')}</th>
                <th className="px-4 py-2 border-b dark:border-gray-700">{t('createdAt')}</th>
                <th className="px-4 py-2 border-b dark:border-gray-700">{t('actions')}</th>
              </tr>
            </thead>
            <tbody>
              {articles.map(article => (
                <tr key={article._id} className="text-center">
                  <td className="px-4 py-2 border-b dark:border-gray-700">{article.title}</td>
                  <td className="px-4 py-2 border-b dark:border-gray-700">
                    {new Date(article.createdAt).toLocaleString()}
                  </td>
                  <td className="px-4 py-2 border-b dark:border-gray-700">
                    <button
                      onClick={() => {
                        // 編輯功能
                        navigate(`/admin/articles/edit/${article._id}`);
                      }}
                      className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-1 px-2 rounded"
                    >
                      {t('edit')}
                    </button>
                    {/* 刪除按鈕已移除 */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminArticles;
